module.exports = __webpack_public_path__ + "img/icon-supervisor-intro1.671a8606.png";